import { AxiosInstance } from 'axios'

export const postForm = async (client: AxiosInstance, data: Record<string, FormDataEntryValue>) => {
  const path = '/lead-form'
  return await client.post(path, data)
}
